import { useEffect } from 'react';

// Performance monitoring component for Core Web Vitals
export const PerformanceMonitor = () => {
  useEffect(() => {
    // Only run in production
    if (process.env.NODE_ENV === 'production') {
      const reportVitals = (metric: any) => {
        // Report to analytics service
        console.log('Web Vital:', metric.name, metric.value);
        
        // You can send this to your analytics service
        // analytics.track('web_vital', {
        //   name: metric.name,
        //   value: metric.value,
        //   id: metric.id,
        //   delta: metric.delta
        // });
      };

      // Dynamic import to avoid build issues
      import('web-vitals').then(({ onCLS, onINP, onFCP, onLCP, onTTFB }) => {
        onCLS(reportVitals);
        onINP(reportVitals); // onFID is deprecated, replaced by onINP
        onFCP(reportVitals);
        onLCP(reportVitals);
        onTTFB(reportVitals);
      }).catch(() => {
        // Silently fail if web-vitals is not available
        console.log('Web vitals monitoring not available');
      });
    }

    // Performance observer for resource timing
    if ('PerformanceObserver' in window) {
      try {
        const observer = new PerformanceObserver((list) => {
          list.getEntries().forEach((entry) => {
            // Log slow resources (>2s)
            if (entry.duration > 2000) {
              console.warn('Slow resource detected:', entry.name, `${entry.duration}ms`);
            }
          });
        });

        observer.observe({ entryTypes: ['resource'] });

        return () => observer.disconnect();
      } catch (error) {
        console.log('Performance observer not available');
      }
    }
  }, []);

  return null;
};

export default PerformanceMonitor;